var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInputPassword = function SvgInputPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 .692c-2.565 0-4.644 2.062-4.644 4.605v.891q0 .081.02.155a4.02 4.02 0 0 0-2.447 2.52c-.198.604-.198 1.35-.198 2.84s0 2.235.198 2.838a4.02 4.02 0 0 0 2.592 2.57c.609.197 1.36.197 2.864.197h3.23c1.504 0 2.256 0 2.864-.196a4.02 4.02 0 0 0 2.593-2.57c.197-.604.197-1.35.197-2.84s0-2.235-.197-2.838a4.02 4.02 0 0 0-2.448-2.52.6.6 0 0 0 .02-.156v-.891C13.644 2.754 11.565.692 9 .692M7.385 6.097c-.78 0-1.357 0-1.817.028v-.828c0-1.88 1.536-3.404 3.432-3.404s3.433 1.524 3.433 3.404v.828c-.46-.028-1.038-.028-1.817-.028zm2.22 4.004c0-.332-.27-.6-.605-.6a.603.603 0 0 0-.606.6v3.203c0 .332.271.6.606.6a.603.603 0 0 0 .606-.6z",
    clipRule: "evenodd"
  })));
};
export { SvgInputPassword as ReactComponent };